import { useState } from "react";
import { VendorEnquiryResponseComparisionDetailsByID } from "../../services/vendorEnquiryService";

const useEnquiryResponseComparisionDetByID = () => {
  const [comparisonHeader, setComparisonHeader] = useState(null);
  const [comparisonDetails, setComparisonDetails] = useState([]);
  const [hdrId, setHdrId] = useState(null);

  // Fetch vendor comparison full data by header ID
  const fetchVendorComparisonFull = async (headerId) => {
    try {
    
       const data = await VendorEnquiryResponseComparisionDetailsByID(headerId);
      
      if (data) {
        const { header, details } = data;

        setComparisonHeader(header || null);
        setComparisonDetails(details || []);
        setHdrId(headerId);

        return data; // return to caller
      }

      return { header: null, details: [] };

    } catch (error) {
      console.error("Error fetching vendor comparison full:", error);
      return { header: null, details: [] };
    }
  };

  // Function to call when user selects a comparison from the list
  const loadVendorComparisonByHdrId = async (headerId) => {
    const data = await fetchVendorComparisonFull(headerId);
    return data;
  };

  return {
    comparisonHeader,
    comparisonDetails,
    hdrId,
    loadVendorComparisonByHdrId,
  };
};

export default useEnquiryResponseComparisionDetByID;
